export default __webpack_public_path__ + "static/media/blueguard.342b7837.png";